"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _RetailPriceChartContainer = _interopRequireDefault(require("../../../RetailPriceChart/RetailPriceChartContainer"));
var _InstrumentTableContainer = _interopRequireDefault(require("../../../InstrumentTable/InstrumentTableContainer"));
var _BuySellChartIntervalSelector = _interopRequireDefault(require("../BuySellChartIntervalSelector"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./BuySellChartOverviewComponent.css");
var _InstrumentTableItems = _interopRequireDefault(require("../../../InstrumentTable/InstrumentTableItems"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var chartOverviewClasses = (0, _cssClassesHelper.getBEMClasses)('chart-overview');
var BuySellChartOverviewComponent = function BuySellChartOverviewComponent(_props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('chart-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('title-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('title')
  }, "Price Chart"), /*#__PURE__*/_react["default"].createElement(_BuySellChartIntervalSelector["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('instruments-bar-container')
  }, /*#__PURE__*/_react["default"].createElement(_InstrumentTableContainer["default"], {
    customClass: "chart-overview-alt-layout-top",
    items: [{
      field: _InstrumentTableItems["default"].lastPrice
    }, {
      field: _InstrumentTableItems["default"].dailyPercentageChange
    }, {
      field: _InstrumentTableItems["default"].dailyVolume
    }]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('chart-overview-container')
  }, /*#__PURE__*/_react["default"].createElement(_RetailPriceChartContainer["default"], {
    customClass: "chart-overview-alt-layout"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('instruments-bar-container')
  }, /*#__PURE__*/_react["default"].createElement(_InstrumentTableContainer["default"], {
    customClass: "chart-overview-alt-layout-bottom",
    items: [{
      field: _InstrumentTableItems["default"].bid
    }, {
      field: _InstrumentTableItems["default"].ask
    }, {
      field: _InstrumentTableItems["default"].dailyMax
    }, {
      field: _InstrumentTableItems["default"].dailyMin
    }]
  })));
};
var _default = exports["default"] = BuySellChartOverviewComponent;